import React, { useCallback, useContext, useEffect, useState } from "react";
import { InformeMovimientosActivosContext } from ".";
import moment from 'moment';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { getAsignaciones } from "../../../services/request/requestSolicitudesAsignacion";
Highcharts.setOptions({
  lang: {
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    shortMonths: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    weekdays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    shortWeekdays: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"]
  }
});

export default function GraficoLineaAsignaciones() {

  const { desde, hasta } = useContext(InformeMovimientosActivosContext);

  const [data, setData] = useState([]);

  const loadData = useCallback(async () => {
    try {
      setData([]);
      const data = [];
      const response = await getAsignaciones({
        fecha_creacion_lt: hasta,
        fecha_creacion_gt: desde
      }, ["fecha_creacion"],
        []);
      if (response) {
        for (let i = 0; i < response.length; i++) {
          const value = response[i];
          if (value.fecha_creacion) {
            const fechaActivacion = moment(value.fecha_creacion).startOf('day').valueOf();
            const fechaData = data.find(a => a[0] === fechaActivacion);
            if (fechaData) fechaData[1]++;
            else data.push([
              fechaActivacion,
              1
            ]);
          }
        }
      }
      setData(data.sort((a, b) => a[0] - b[0]));

    } catch (error) {
      console.error(error);
      throw error;
    }
  }, [desde, hasta]);



  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        title: {
          text: "Asignaciones"
        },
        yAxis: {
          title: { text: null }
        },
        xAxis: {
          type: 'datetime'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:.1f}</b>'
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            },
            pointStart: desde.getFullYear()
          }
        },
        series: [{
          data: data
        }]
      }}
    />
  );
}